export default {"src":"/_next/static/media/privacy-assessment.6aa9c4b8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};